// extracted by mini-css-extract-plugin
export default {"burger":"Layout_burger__eKmbn","mainContent":"Layout_mainContent__NyGQv","burgerHidden":"Layout_burgerHidden__0Wzmu"};